module.exports = __webpack_public_path__ + "img/qing.a1374f03.png";